import { APIRoutes } from "@/api";
import { Intervals } from "@/constants";
import { queryClient } from "@/lib/query-client";
import { ApiService } from "@/services/api/api-service";
import {
  AssetLatestPricesSchema,
  AssetLatestPrices as TData,
} from "@/services/assets/schema";

import {
  QueryFunctionContext,
  UseQueryOptions,
  useQuery as useQueryTanstack,
} from "@tanstack/react-query";

const REFETCH_INTERVAL = Intervals.SECOND * 7;

async function getLatestPrices({
  signal,
}: QueryFunctionContext<typeof AssetLatestPrices.queryKey>) {
  const data = await fetch(APIRoutes.ASSET_PRICES, {
    cache: "no-cache",
    signal,
  }).then((res) => res.json());
  const result = ApiService.parseApiResponse(data, AssetLatestPricesSchema);
  if (result.status === "success") {
    return result.data;
  }

  return null;
}

export namespace AssetLatestPrices {
  export const queryKey = ["asset-prices"] as const;

  export function getData() {
    return queryClient.getQueryData<TData | null>(queryKey);
  }

  export function useQuery(
    options?: Omit<
      UseQueryOptions<TData | null, unknown, TData | null, typeof queryKey>,
      "queryKey" | "queryFn" | "refetchInterval"
    >,
  ) {
    return useQueryTanstack({
      queryKey,
      queryFn: getLatestPrices,
      refetchInterval: REFETCH_INTERVAL,
      ...options,
    });
  }
}
